import { render, staticRenderFns } from "./CoursewareTableOfContentsBlock.vue?vue&type=template&id=7de257fe&scoped=true&"
import script from "./CoursewareTableOfContentsBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareTableOfContentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTableOfContentsBlock.vue?vue&type=style&index=0&id=7de257fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de257fe",
  null
  
)

export default component.exports